// extracted by mini-css-extract-plugin
export var callCard = "_m1-0";
export var callMessageButton = "_m1-1";
export var helpIcon = "_m1-3";
export var helpIconContainer = "_m1-4";
export var verticalDivider = "_m1-2";